export const formatPassengersForQuery = (passengers: string[]) => {
  return Object.keys(passengers).reduce((acc, passengerKey) => {
    if (passengers[passengerKey] !== 0) {
      acc[passengerKey] = passengers[passengerKey];
    }
    return acc;
  }, {});
};
